// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__B6aCW","scroller":"Table_scroller__jXqYJ","table":"Table_table__YUzYe","header":"Table_header__rwKnO"};